$(function () {
  $('#animated').on('click', function (e) {
    e.preventDefault();
    var box = $("#sitedescriptiondata");
    box.slideToggle('slow');
  });
});